import React, { Dispatch, SetStateAction } from 'react';
import './AddWinButton.css'
import { AddWinButtonProps } from '../types';

const AddWinButton: React.FC<AddWinButtonProps> = ({ setDisplayNewBlankItem }) => {
  const onClickButton = (setDisplayNewBlankItem: Dispatch<SetStateAction<boolean>>) => {
    setDisplayNewBlankItem(true);
  }

  return (
    <div className='add-win-cta'>
      <div className='add-win-button' onClick={(e) => onClickButton(setDisplayNewBlankItem)}>+</div>
    </div>
  );
};

export default AddWinButton;
